import { Card } from './card';

/**
 * Skeleton loader for table/list layouts.
 */
export function TableSkeleton({ rows = 6 }: { rows?: number }) {
	return (
		<Card className="overflow-hidden border-line-1 bg-surface">
			{Array.from({ length: rows }).map((_, i) => (
				<div
					key={i}
					className="flex items-center gap-4 px-4 py-3.5"
					style={{
						borderBottom: i < rows - 1 ? '0.5px solid var(--line-1)' : 'none',
					}}
				>
					<div className="h-8 w-8 animate-pulse rounded-[var(--r-2)] bg-surface-fill" />
					<div className="h-4 w-32 animate-pulse rounded bg-surface-fill" />
					<div className="h-3 w-40 animate-pulse rounded bg-surface-fill" />
					<div className="ml-auto h-5 w-16 animate-pulse rounded bg-surface-fill" />
				</div>
			))}
		</Card>
	);
}
